import React from 'react';
import ReviewWrapper from './ReviewWrapper';

// 20220120JP: SEO is added when the quiz is loaded.
const Share = (props) => {
  const { history, match } = props;

  return <ReviewWrapper history={history} match={match} mode="share" />;
};

export default Share;
